module.exports = __webpack_public_path__ + "static/digital-solutions-3dc7af34e1ecf7a7852910ee158afca4.jpg";